<template>
  <div v-if="relatedProducts && relatedProducts.length">
    <div ref="relatedProductSelector">
      <div class="mb-24 relative w-full mt-0">
        <div
          class="p-4 pr-16 border border-grey400 rounded-md flex justify-between items-center select-none cursor-pointer text-xs sm:text-sm"
          :class="{
            'rounded-b-none': productSelectorOpen
          }"
          @click="productSelectorOpen = !productSelectorOpen"
        >
          <div class="flex items-center base-text">
            <div class="h-48 w-48 bg-grey200 rounded-md mr-12 flex items-center justify-center">
              <img
                :src="product.imageUrl"
                class="h-[34px] w-[34px] object-contain"
                width="34"
                height="34"
                :alt="product.name"
              >
            </div>
            <span v-if="isBundleProduct" class="font-medium pr-6">{{ productResources.relatedProductsMixPackages }}:</span>
            <span v-else class="font-medium pr-6">{{ productResources.relatedProductsStandardProducts }}:</span>
            {{ product.name }}
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-12 h-12"
            viewBox="0 0 512 512"
          ><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" /></svg>
        </div>
        <transition name="fade" mode="out-in">
          <div
            v-show="productSelectorOpen"
            class="bg-white z-10 rounded-b-sm border-b border-r border-l border-grey400 overflow-auto cursor-pointer select-none text-xs sm:text-sm"
          >
            <nuxt-link
              v-for="relatedProduct in relatedProducts"
              :key="relatedProduct.id"
              :to="relatedProduct.url"
              class="flex p-4 items-center base-text"
              @click="onRelatedProductClick(relatedProduct.name)"
            >
              <div class="h-48 w-48 bg-grey200 rounded-md mr-12 flex items-center justify-center">
                <img
                  :src="relatedProduct.imageUrl"
                  class="h-[34px] w-[34px] object-contain"
                  width="34"
                  height="34"
                  :alt="relatedProduct.name"
                >
              </div>
              {{ relatedProduct.name }}
            </nuxt-link>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
  
<script setup lang="ts">
import type { IProduct, IProductPageData } from '~/api-types';
import { useGlobalContentStore } from '~/store/globalContent';
const productResources = useGlobalContentStore().productResources;
const productSelectorOpen = ref();
const relatedProductSelector = ref();
  
const props = defineProps<{
  product: IProduct,
  isBundleProduct?: boolean,
  page: IProductPageData
}>();
  
useDetectOutsideClick(relatedProductSelector, () => {
  productSelectorOpen.value = false;
});

const relatedProducts = computed(() => {
  const relationTypes = ['IncludedProduct', 'alternative'];
  return props.page.relatedProducts?.filter((relation) => relationTypes.includes(relation.type))
    .map((relation) => relation.product);
});

const onRelatedProductClick = (productName: string) => {
  window.dataLayer?.push({
    event: 'product_selector',
    selected_product: productName,
  });
};
</script>
  
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
